import StoredFilters from 'utils/stored_filters';
import ModalManager from 'utils/modal_manager';
import FilterFormTracker from 'utils/filter_form/options/track';
import 'utils/serialize_object';
import './index.scss';

(function ($) {
  'use strict';

  const handleSuggestion = (segmentId) => {
    const $suggestionBox = $('#js-new-filter-modal .q-suggestion-box');
    const $loadingBox = $('#js-new-filter-modal .q-suggestion-loading');

    $suggestionBox.hide();
    $loadingBox.hide();

    if ($suggestionBox.length === 0 || segmentId !== 7) return;

    $loadingBox.show();

    const data = new FilterFormTracker("#js-questions-filter-form").parse();
    let magicName = "";

    const request = fetch('https://niamh.grupoq.io/api/concursos/stored_filters/name', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    request.then(async (response) => {
      const body = await response.json();
      magicName = body.result.name;
    }).finally(() => {
      if (magicName.length > 0) {
        $('#js-new-filter-modal .q-suggestion-name').text(magicName);
        $loadingBox.hide();

        
        $suggestionBox.show().animate({
          opacity: 1
        }, 600, function() {
          setTimeout(() => {
            $(this).css('box-shadow', 'none').css('animation', 'none');
          }, 4000);
        });
      }
    });
  }

  $('.js-filter-form').on('click', '.js-btn-save', (event) => {
    const $button = $(event.currentTarget);
    const {segmentId, product, limitReached} = $button.data();

    if (limitReached === true) return;

    handleSuggestion(segmentId);

    UserTracker.emit('event', {eventName: 'stored filter creation started'});

    ModalManager.open('#js-new-filter-modal', (formData, $formEvent) => {
      const name = $formEvent.find('[name="filter-name"]').val();
      const serialized = $('.js-filter-form').serializeObject();

      StoredFilters.save(name, product, segmentId, serialized, $button);
    });

  });

  $('#js-new-filter-modal').on('click', '.q-suggestion-box', (event) => {
    UserTracker.emit('event', {eventName: 'stored filter suggestion name used'});
    const suggestion = $('.q-suggestion-name').text();
    const $input = $('#js-new-filter-modal').find('[name="filter-name"]');
    $input.val(suggestion);
  })

})(jQuery);

